import { render, staticRenderFns } from "./partsquery.vue?vue&type=template&id=267c83b9&scoped=true&"
import script from "@/service/partsqueryservice.js?vue&type=script&charset=utf-8&lang=js&"
export * from "@/service/partsqueryservice.js?vue&type=script&charset=utf-8&lang=js&"
import style0 from "./partsquery.vue?vue&type=style&index=0&id=267c83b9&scoped=true&lang=scss&"
import style1 from "./partsquery.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267c83b9",
  null
  
)

export default component.exports